var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCard = function SvgCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11611 10.6023C5.11611 10.9889 4.8027 11.3023 4.41611 11.3023C4.02951 11.3023 3.7161 10.9889 3.7161 10.6023C3.7161 10.2157 4.02951 9.90234 4.41611 9.90234C4.8027 9.90234 5.11611 10.2157 5.11611 10.6023Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1317 2.49414C13.5677 2.49414 14.7317 3.6582 14.7317 5.09414V10.9055C14.7317 12.3414 13.5677 13.5055 12.1317 13.5055H3.86758C2.43164 13.5055 1.26758 12.3414 1.26758 10.9055V5.09414C1.26758 3.6582 2.43164 2.49414 3.86758 2.49414H12.1317ZM13.5317 5.09414C13.5317 4.32094 12.9049 3.69414 12.1317 3.69414L3.86758 3.69414C3.09438 3.69414 2.46758 4.32094 2.46758 5.09414V5.40039L13.5317 5.40039V5.09414ZM13.5317 6.60039H2.46758L2.46758 10.9055C2.46758 11.6787 3.09438 12.3055 3.86758 12.3055H12.1317C12.9049 12.3055 13.5317 11.6787 13.5317 10.9055L13.5317 6.60039Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "card.2213af412a4b3a52e0f33a86eccfa055.svg";